const apiUrl = process.env.REACT_APP_API_URL;

/** Comprova si la remesa ja està volcada a rebuts_loop. Retorna boolean. */
export const CheckRemesaVolcada = async (idRemesa: string, page: string, token: string) => {
    try {
        const response = await fetch(`${apiUrl}:8073/generarpdf/${idRemesa}/volcada`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page,
                'token': token
            }
        });
        if (response.ok) {
            return await response.json();
        }
        return false;
    } catch (error) {
        console.error('Error al comprovar la remesa', error);
        return false;
    }
};

/** Volca la remesa des de la BD loop cap a rebuts_loop. Retorna missatge de resultat. */
export const VolcarRemesa = async (idRemesa: string, retorn: boolean, page: string, token: string) => {
    try {
        const response = await fetch(`${apiUrl}:8073/generarpdf/${idRemesa}/volcar?retorn=${retorn}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page,
                'token': token
            }
        });
        const text = await response.text();
        return {ok: response.ok, message: text};
    } catch (error) {
        console.error('Error al volcar la remesa', error);
        return {ok: false, message: 'Error al volcar la remesa'};
    }
};

/** Descarrega el PDF des de rebuts_loop. Retorna un object URL del blob. */
export const DescarregarPdfLoop = async (idRemesa: string, page: string, token: string) => {
    return descarregar(`${apiUrl}:8073/generarpdf/${idRemesa}/pdf-loop`, page, token);
};

/** Descarrega el PDF des de la taula facturacio. Retorna un object URL del blob. */
export const DescarregarPdfFacturacio = async (idRemesa: string, page: string, token: string) => {
    return descarregar(`${apiUrl}:8073/generarpdf/${idRemesa}/pdf-facturacio`, page, token);
};

const descarregar = async (url: string, page: string, token: string) => {
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page,
                'token': token
            }
        });
        if (response.ok) {
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } else {
            alert(await response.text());
        }
        return "";
    } catch (error) {
        console.error('Error al descarregar el document', error);
        return "";
    }
};
